import { TrendingUp, TrendingDown } from "lucide-react";
import { formatCurrency } from "@/lib/data";

interface ProfitIndicatorProps {
  profit: number;
  percent: number;
  isProjected?: boolean;
}

export function ProfitIndicator({ profit, percent, isProjected }: ProfitIndicatorProps) {
  const isPositive = profit >= 0;
  
  return (
    <div className="flex flex-col items-end">
      <span className={`text-sm font-semibold ${isPositive ? 'text-emerald-600' : 'text-red-600'}`}>
        {isPositive ? '+' : ''}{formatCurrency(profit)}
      </span>
      <div className="flex items-center gap-1">
        {isPositive ? (
          <TrendingUp className="w-3 h-3 text-emerald-500" />
        ) : (
          <TrendingDown className="w-3 h-3 text-red-500" />
        )}
        <span className={`text-xs ${isPositive ? 'text-emerald-600' : 'text-red-600'}`}>
          {percent.toFixed(1)}%
        </span>
        {isProjected && (
          <span className="text-xs text-amber-600 ml-1">(proj)</span>
        )}
      </div>
    </div>
  );
}
